export default {
  mounted () {
    this.$store.commit('fieldRecordSystem/map/setDefaultInteractionsEnabled', false)
  },
  beforeDestroy () {
    this.$store.commit('fieldRecordSystem/map/setDefaultInteractionsEnabled', true)
  }
}
